import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DataGrid } from '@mui/x-data-grid';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import * as CustomStyles from '../../styles/CustomStyles';
import * as Security from '../../../utils/auth/Security';
import {Loading} from '../../custom/LoadingComponent'
import BucketContext from '../../context/BucketContext';
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';
import { RoleClient } from '../../constants/Consts';
import * as AFFragment from '../../custom/AFFragment';

const Employers =(props) => {
    console.log('___Employers___');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData();
    }, []);

    // var contextClientId = '';
    // if( !!bucketContext.bucket.userContext?.clientId && props.clients.status === ReduxDataStatus.SUCCEEDED){
    //     contextClientId = bucketContext.bucket.userContext.clientId != Consts.COREVO_CLIENT_ID ? bucketContext.bucket.userContext.clientId : '';
    // }

    // const clientSelectData = TypeConvertor.getClientSelectData(props.clients.clients);
    // const [selectedClientId, setSelectedClientId] = React.useState( contextClientId );

    // const handleClientChange = (clientId) => {
    //     setSelectedClientId(clientId);
    //     bucketContext.setBucketValue({userContext: {clientId: clientId}});
    // }

    const getClientName = (clientId) => {
        return props.clients.clients.filter( (client) => client.id === clientId )
                        .map( (client) => client.generalSection.clientName );
    }

    const columns = [
        {
            field: 'name',
            headerName: 'Angajator',
            width: 325,
            valueGetter: (params) => params.row.generalSection.employerName,
            renderCell: (params) => {
                return (
                    <Link to={`/employers/${params.row.id}`}>
                        {params.row.generalSection.employerName}
                    </Link>
                );
            }
        },
        {
            field: 'judet',
            headerName: 'Judet',
            width: 150,
            valueGetter: (params) => params.row.headOffice.judet
        },
        {
            field: 'localitate',
            headerName: 'Oras',
            width: 150,
            valueGetter: (params) => params.row.headOffice.localitate
        },
        {
            field: 'rsvtiMB',
            headerName: 'Responsabil RSVTI',
            width: 250,
            valueGetter: (params) => getClientName(params.row.generalSection.rsvtiMBClientId)
        }
    ];    

    // if (props.employers.isLoading) {
    if (props.dataStatus.status === ReduxDataStatus.LOADING) {
            return(
            <Container maxWidth="xl" >
                <Box px={{xs: 3, sm: 7}}>
                    <Loading />
                </Box>
            </Container>
        );
    }
    else { 
        return(
            <React.Fragment>
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Angajatori</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <h3>Angajatori</h3>
                            {Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) ?
                                <React.Fragment></React.Fragment>
                                :
                                <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                    <Link to={'/newemployer'}>
                                        <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Angajator</Button>
                                    </Link>
                                </Box>
                            }
                        </Box>                
                    </Box>
                    <hr />

                    {Security.isSystemUser() &&
                        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                            {/*row*/}
                            <Grid item xs={4}>
                                <AFFragment.ClientContextSection clients={props.clients.clients}/>
                            </Grid>
                        </Grid>
                    }

                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        <DataGrid
                            rows={props.employers.employers}
                            columns={columns}
                            initialState={{
                                sorting: { sortModel: [{ field: 'name', sort: 'asc' }] }
                            }}                            
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box>
                </Stack>

            </Box>
            </Container>
            </React.Fragment>
        );
    }
}

export default Employers;